// extracted by mini-css-extract-plugin
export default {"svgWrapper":"VehicleTypes_svgWrapper__WTLyH","svgCanvas":"VehicleTypes_svgCanvas__2BseI","svg":"VehicleTypes_svg__bKaUN"};